export enum ScreenshotType {
    FULL = "full",
    VISIBLE = "visible"
}